export default __webpack_public_path__ + "static/media/market-kr.669e0ba3.webp";